import Chip from '@ixigo/iui/Chip';
import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import { getProductIconAndTitle } from '../BookingCard/helper';
import { getBookingInfo } from './helper';
import { BookingInfoProps } from './index.types';

const BookingInfo: FC<BookingInfoProps> = ({ data }) => {
    let iconLeft;
    if (data) {
        iconLeft = getProductIconAndTitle(data.product).icon;
    }
    const info = getBookingInfo(data);

    return (
        <Chip size='sm' variant='soft' iconLeft={iconLeft}>
            <Typography as='span' variant='body-xs'>
                {info}
            </Typography>
        </Chip>
    );
};

export default BookingInfo;
